import type { StorageMethod } from './types';

export const SUPPORTED_STORAGE_METHODS: StorageMethod[] = [
  'GCS',
  'B2',
  'S3',
  'AZURE',
];

/* cspell:disable */
// List of ignore files initially taken from https://github.com/sindresorhus/junk
const IGNORE_FILE_LIST = [
  // # macOS
  '^\\.DS_Store$', // Stores custom folder attributes
  '^\\.AppleDouble$', // Stores additional file resources
  '^\\.LSOverride$', // Contains the absolute path to the app to be used
  '^Icon\\r$', // Custom Finder icon: http://superuser.com/questions/298785/icon-file-on-os-x-desktop
  '^\\._.*', // Thumbnail
  '^\\.Spotlight-V100(?:$|\\/)', // Directory that might appear on external disk
  '\\.Trashes', // File that might appear on external disk
  '^__MACOSX$', // Resource fork

  // FCP bundle files
  '^\\.fcpcache', // FCP bundle cache which is a recursive symlink
  '^\\.lock',
  '^\\.lock-dir',
  '^\\.lock-info',
  '^__Sync__',
  '^__Temp',

  // # Windows
  '^Thumbs\\.db$', // Image file cache
  '^ehthumbs\\.db$', // Folder config file
  '^[Dd]esktop\\.ini$', // Stores custom folder attributes
  '@eaDir$', // Synology Diskstation "hidden" folder where the server stores thumbnails
] as const;
/* cspell:enable */

/** Regex to match ignored files */
export const IGNORE_FILE_REGEX = new RegExp(IGNORE_FILE_LIST.join('|'));
